var map = {
	"./about1.PNG": 749,
	"./contact.png": 198,
	"./contact2.png": 870,
	"./contact3.png": 63,
	"./github-icon.png": 935,
	"./linux-logo.png": 690,
	"./logo-amd.jpg": 44,
	"./logo-carleton.png": 618,
	"./logo-nokia.png": 328,
	"./logo-nokia2.png": 264,
	"./logo-pathways.png": 129,
	"./logo-pepperdata.jpg": 976,
	"./logo-rbc.png": 729,
	"./logo-sm.png": 728,
	"./profile.jpg": 277,
	"./proj-class.png": 22,
	"./proj-elevator.png": 150,
	"./proj-geo.png": 389,
	"./proj-library.webp": 83,
	"./proj-portfolio.png": 906,
	"./proj-robot.webp": 488,
	"./proj-vision.webp": 168,
	"./project-chat.webp": 968,
	"./project-ghost.png": 403,
	"./project-music.jpg": 271,
	"./qnx-logo.png": 193,
	"./react-logo.png": 123,
	"./vscode-logo.png": 600,
	"./vstudio-logo.png": 708,
	"./windows-logo.png": 233,
	"./yt-icon.png": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;